import { Scroll, StyledFlex } from '@dreryk/react-components';

import { StatisticsHeader } from '../common/StatisticsHeader';
import { statisticsTranslationKeys } from '../translations';

import { StatisticsListTable } from './list/StatisticsListTable';
import { StatisticsOrderTable } from './order/StatisticsOrderTable';

export const StatisticsPanel = (): JSX.Element => (
   <>
      <StatisticsHeader text={statisticsTranslationKeys.menuLabel} testId={'statisticsHeader'} />
      <Scroll testId={'statisticsPanelScroll'}>
         <StyledFlex direction={'column'} flex={'1'} gap={'40px'}>
            <StatisticsListTable />
            <StatisticsOrderTable />
         </StyledFlex>
      </Scroll>
   </>
);
